import WeekManagementScreen from '@/screens/WeekManagementScreen';
import { AdminRouteGate } from '@/components/route/RouteGate';

export default function WeekManagementRoute() {
  return (
    <AdminRouteGate>
      <WeekManagementScreen />
    </AdminRouteGate>
  );
}
